






























































































































import { Component, Ref, Vue, Watch, Prop } from 'vue-property-decorator'
import CandidateService from '@/evaluations/services/candidate-service'
import Candidate from '@/evaluations/entities/candidate'

@Component
export default class EvaluationCandidate extends Vue {
  @Prop({ type: String })
  private candidateId!: string

  @Prop({ type: String })
  private evaluationId!: string

  private candidate: Candidate = new Candidate()

  private professionalImpressionMessage = ''
  private personalImpressionMessage = ''
  private availabilityAndCompensationMessage = ''
  private conclusionMessage = ''

  private async loadCandidateAsync() {
    this.candidate =
      (await CandidateService.findOneAsync(this.candidateId)) || new Candidate()
  }

  private async updateProfessionalImpressionsAsync() {
    await CandidateService.updateAsync(this.candidate)

    this.professionalImpressionMessage = 'Gesichert'
    setTimeout(() => (this.professionalImpressionMessage = ''), 1500)
  }

  private async updatePersonalImpressionsAsync() {
    await CandidateService.updateAsync(this.candidate)

    this.personalImpressionMessage = 'Gesichert'
    setTimeout(() => (this.personalImpressionMessage = ''), 1500)
  }

  private async updateAvailabilityAndCompensationImpressionsAsync() {
    await CandidateService.updateAsync(this.candidate)

    this.availabilityAndCompensationMessage = 'Gesichert'
    setTimeout(() => (this.availabilityAndCompensationMessage = ''), 1500)
  }

  private async updateConclusionImpressionsAsync() {
    await CandidateService.updateAsync(this.candidate)

    this.conclusionMessage = 'Gesichert'
    setTimeout(() => (this.conclusionMessage = ''), 1500)
  }

  private async mounted() {
    await this.loadCandidateAsync()
  }
}
